import { render } from "./ReleaseAccessUpdate.vue?vue&type=template&id=15fdae08&scoped=true"
import script from "./ReleaseAccessUpdate.vue?vue&type=script&lang=js"
export * from "./ReleaseAccessUpdate.vue?vue&type=script&lang=js"

import "./ReleaseAccessUpdate.vue?vue&type=style&index=0&id=15fdae08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15fdae08"]])

export default __exports__